var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppTooltip',{attrs:{"position":"bottom","text":_vm.app.service_name}},[_c('div',{staticClass:"display-flex flex-row flex-align-center card-container"},[_c('v-img',{staticClass:"icon-container",attrs:{"src":_vm.app.icon}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }